import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from '@/api/admin'
import { normalizeCountryCode, bizCodeOfCountry, DEFAULT_COUNTRY_CODE, DEFAULT_BIZ_CODE } from '@/utils/country'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    userInfo: JSON.parse(localStorage.getItem('admin_user_info') || '{}'),
    roles: JSON.parse(localStorage.getItem('admin_roles') || '[]'),
    permissions: JSON.parse(localStorage.getItem('admin_permissions') || '[]'),
    menus: JSON.parse(localStorage.getItem('admin_menus') || '[]'),
    // 登录用户关联国家与业务编码（多国支持）；旧数据缺省 NG / pocketbuy
    countryCode: normalizeCountryCode(localStorage.getItem('admin_country_code')),
    bizCode: localStorage.getItem('admin_biz_code') || DEFAULT_BIZ_CODE
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    roles: state => state.roles,
    permissions: state => state.permissions,
    menus: state => state.menus,
    countryCode: state => state.countryCode,
    bizCode: state => state.bizCode,
    hasPermission: state => code => {
      const list = state.permissions || []
      return Array.isArray(code)
        ? code.some(c => list.indexOf(c) !== -1)
        : list.indexOf(code) !== -1
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('admin_user_info', JSON.stringify(userInfo))
    },
    SET_ROLES(state, roles) {
      state.roles = roles
      localStorage.setItem('admin_roles', JSON.stringify(roles))
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions || []
      localStorage.setItem('admin_permissions', JSON.stringify(state.permissions))
    },
    SET_MENUS(state, menus) {
      state.menus = menus || []
      localStorage.setItem('admin_menus', JSON.stringify(state.menus))
    },
    // 写入登录用户国家上下文；bizCode 由国家码推导（单一映射来源 utils/country），保证与后端一致性校验匹配
    SET_COUNTRY_CONTEXT(state, { countryCode, bizCode }) {
      const normalized = normalizeCountryCode(countryCode)
      state.countryCode = normalized
      state.bizCode = bizCodeOfCountry(normalized)
      localStorage.setItem('admin_country_code', normalized)
      localStorage.setItem('admin_biz_code', state.bizCode)
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = {}
      state.roles = []
      state.permissions = []
      state.menus = []
      state.countryCode = DEFAULT_COUNTRY_CODE
      state.bizCode = DEFAULT_BIZ_CODE
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user_info')
      localStorage.removeItem('admin_roles')
      localStorage.removeItem('admin_permissions')
      localStorage.removeItem('admin_menus')
      localStorage.removeItem('admin_country_code')
      localStorage.removeItem('admin_biz_code')
    }
  },
  actions: {
    login({ commit }, payload) {
      const { token, userInfo, roles, permissions, menus, countryCode, bizCode } = payload
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      commit('SET_ROLES', roles)
      commit('SET_PERMISSIONS', permissions)
      commit('SET_MENUS', menus)
      commit('SET_COUNTRY_CONTEXT', { countryCode, bizCode })
    },
    // 从后端刷新当前用户的权限码与菜单（登录后或权限变更后调用）
    async loadPermissions({ commit }) {
      const res = await getUserInfo()
      const data = res.data
      commit('SET_PERMISSIONS', data.permissions || [])
      commit('SET_MENUS', data.menus || [])
      if (data.roleCode) {
        commit('SET_ROLES', [{ roleCode: data.roleCode, roleName: data.roleName }])
      }
      // userinfo 接口新增 countryCode（未设置后端返回 NG）；老后端未返回时不覆盖既有上下文
      const freshCountry = data.countryCode || data.country_code
      if (freshCountry) {
        commit('SET_COUNTRY_CONTEXT', { countryCode: freshCountry, bizCode: data.bizCode })
      }
      return data
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
